import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionProcessing.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { loginApi } from '../http/http';
import { useDispatch } from 'react-redux';
import Lottie from 'lottie-react';
import waitAnimation from "../animations/waitAnimation.json";
import { toast } from 'react-toastify';
import { setUserDetails } from '../store/slices/userSlice';
import { FaCopyright } from 'react-icons/fa6';

const SubscriptionProcessing = () => {
    const location = useLocation();
    const [msisdn, setMsisdn] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [attemptCount, setAttemptCount] = useState(0);

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
        }
        else {
            navigate("/");
        }
    }, [location]);

    useEffect(() => {
        let apiInterval = null;

        if (!loading && msisdn && attemptCount < 100) {
            apiInterval = setInterval(() => {
                handleFormSubmission();
            }, 2000);
        }

        if (attemptCount > 100) {
            toast.error("Something Went Wrong!");
            navigate("/login");
        }

        return () => {
            if (apiInterval) {
                clearInterval(apiInterval);
            }
        };
    }, [msisdn, attemptCount, loading]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);
            await loginApi(msisdn)
                .then((res) => {
                    setLoading(false);
                    dispatch(setUserDetails(res?.data?.result));
                    navigate("/home");
                    toast.success("Subscribed Successfully! Login...");
                })
                .catch((err) => {
                    setLoading(false);
                    setAttemptCount(prev => prev + 1);

                    // if (err?.response?.data?.error?.status == 1) {
                    //     toast.error("Low Balance! You have not been charged!");
                    //     navigate("/");
                    // }
                });
        } catch (error) {
            setLoading(false);
            setAttemptCount(prev => prev + 1);
            console.log(error, 'error--');
        }
    }

    return (

        <main className={classes.main}>
            <header className={classes.header}>
                <nav className={classes.nav}>
                    <div className={classes.logo_container}>
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                    </div>

                    {/* <div className={classes.nav_items}>
                        <button type="button" className={classes.nav_item_btn}
                            onClick={() => navigate(`/subscribe?ext_ref=${extRef}`)}
                        >
                            Subscribe
                        </button>
                    </div> */}
                </nav>
            </header>


            <section className={classes.section_landing_page}>
                <div className={classes.grid_container}>
                    <div className={classes.grid_section_one}>
                        <div className={classes.container}>
                            <div className={classes.description}>
                                <h2 className={classes.title}>Subscription In Process</h2>
                                <ul className={classes.list}>
                                    <li className={classes.text}>
                                        Dear User, your subscription is in process!
                                    </li>
                                </ul>

                                <div className={classes.animation_container}>
                                    <Lottie animationData={waitAnimation} loop autoPlay className={classes.animation} />
                                </div>

                                <p className={classes.text2}>
                                    You will be auto redirected when successfully subscribed!
                                </p>
                            </div>
                        </div>

                    </div>
                    {/* <div className={classes.grid_section_two}>
                        <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />


                        <p className={classes.portal_description}>
                            Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                        </p>

                        <div className={classes.grid_sub_container}>
                            <div className={classes.kids_image_container}>
                                <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                            </div>
                            <div className={classes.kids_info}>
                                <p className={classes.kids_info_text_one}>Made For</p>
                                <p className={classes.kids_info_text_two}>- Kids</p>
                            </div>
                        </div>
                    </div> */}

                </div>
                <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

            </section>

            <section className={classes.footer}>
                <div className={classes.container}>
                    <div className={classes.footer_container}>
                        <div className={classes.footer_logo_container}>
                            <img src="/assets/images/logo.png" alt="logo" className={classes.footer_logo} />
                        </div>

                        <div className={classes.copyright_container}>
                            <FaCopyright className={classes.copyright_icon} />
                            <p className={classes.copyright_text}>
                                Rainboo Softmate Pvt Ltd
                            </p>
                        </div>
                    </div>


                </div>
            </section>

        </main>




    )
}

export default SubscriptionProcessing